import React from "react";
import { View } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";


const CView = ({ W100,H100,W50,Z9,H60,MT20, width,   P10, P10H, P20, P20H, P24,ML, P24H, P30, P30H,P60H, MT,MR,FR, FC, JC, JE, JS, AC, AE, AS, ABSB, ABST, GAP,height, children, style = {}, ...otherProps }) => {
    let justifyContent = "flex-start";
    let alignItems = "flex-start";
    let padding = 0;
    let paddingHorizontal = 0;
    let flexDirection = "column";
    let position = "relative";
    let gap = 0
    let bottom = 1;
    let top = 1;
    let marginTop = 0 
    let marginLeft = 0 
    let marginRight = 0

    //----------------------------
    let extraStyle = {};
    if (W100) {extraStyle = { width: "100%"}}
    if (W50) {extraStyle = { ...extraStyle,width: "50%"}}
    if(H100){extraStyle = {...extraStyle, height: "100%"}}
    if(H60){extraStyle = {...extraStyle, height: "60%"}}
    if(Z9){extraStyle = { ...extraStyle,zIndex: 9  }}
    if(MT20){marginTop=20}
    if(width){{extraStyle = { width:`${width}%`}}}
   

    if (ABSB) {
        position = "absolute";
        bottom = 0;
    }
    if (ABST) {
        position = "absolute";
        top = 0;
    }
    if (JC) {
        justifyContent = "center";
    }
    if (JE) {
        justifyContent = "flex-end";
    }
    if (JS) {
        justifyContent = "space-between";
    }
    if (AC) {
        alignItems = "center";
    }
    if (AE) {
        alignItems = "flex-end";
    }
    if (AS) {
        alignItems = "flex-start";
    }
    if (P10) {
        padding = 10;
        paddingHorizontal = 10;
    }
    if (P10H) {
        padding = 0;
        paddingHorizontal = 10;
    }
    if (P20) {
        padding = 20;
        paddingHorizontal = 20;
    }
    if (P20H) {
        padding = 0;
        paddingHorizontal = 20;
    }
    if (P24) {
        padding = 24;
        paddingHorizontal = 24;
    }
    if (P24H) {
        padding = 0;
        paddingHorizontal = 24;
    }
    if (P30) {
        padding = 30;
        paddingHorizontal = 30;
    }
    if (P30H) {
        padding = 0;
        paddingHorizontal = 30;
    }
    if (P60H) {
        padding = 0;
        paddingHorizontal = 60;
    }
    if (FR) {
        flexDirection = "row";
    }
    if (FC) {
        flexDirection = "column";
    }
    if(MT){marginTop= MT}
    if(GAP){gap=GAP}
    if(ML){marginLeft = ML}
    if(MR){marginRight = MR}


    

    return (
        // <View style={{ padding,marginRight, paddingHorizontal, marginLeft,  marginTop,gap,justifyContent, alignItems, flexDirection, position, ...extraStyle, ...style }} {...otherProps}>
        //     {children}
        // </View>
        <View  style = {{marginTop,...extraStyle}}>
            {children}
        </View>
    )
};
const useStyles = CreateResponsiveStyle({
  row:{flexDirection: "row"},
  column:{flexDirection: "column"}
  }, {
    [DEVICE_SIZES.XS]: {
        row: {flexDirection: "column"},
    }
  });
export default CView;